import * as types from '../actions/types';

const initialState = null

export default function carousel (state = initialState, action) {
  switch (action.type) {
    case types.SET_CAROUSEL_DATA:
      return action.payload
    default:
      return state;
  }
}
